import { Component } from '@angular/core';
import { ModalService } from 'src/app/shared/components/modal/modal.service';
import { AuthService } from 'src/app/shared/utils/services/auth.service';

@Component({
  selector: 'app-acknowledgment-modal',
  templateUrl: './acknowledgment-modal.component.html',
  styleUrls: ['./acknowledgment-modal.component.scss']
})
export class AcknowledgmentModalComponent {

  public userPrimeiroNome: string;

  constructor(
    private modal: ModalService,
    private authService: AuthService
  ) { 
    this.userPrimeiroNome = this.authService.getUser().name.split(' ')[0];
  }

  public onClose(): void {
    this.modal.closeModal();
  }
}
